import notifications from "@assets/web-v3-images/icons/notifications.png";

const NotificationsIcon = ({ width = 96, height = 96, className }) => (
  <img src={notifications} alt="Notifications" width={width} height={height} className={className} />
);

export default NotificationsIcon;
